// TODO: убрать этот хардкод
export const category = [
    {
        url: 'stroymaterialy',
        name: 'Стройматериалы'
    },
    {
        url: 'stolyarnye-izdeliya',
        name: 'Столярные изделия'
    },
    {
        url: 'elektrotovary',
        name: 'Электротовары'
    },
    {
        url: 'instrumenty',
        name: 'Инструменты'
    },
    {
        url: 'napolnye-pokrytiya',
        name: 'Напольные покрытия'
    },
    {
        url: 'plitka',
        name: 'Плитка'
    },
    {
        url: 'santehnika',
        name: 'Сантехника'
    },
    {
        url: 'vodosnabzhenie',
        name: 'Водоснабжение'
    },
    {
        url: 'sad',
        name: 'Сад'
    },
    {
        url: 'skobyanye-izdeliya',
        name: 'Скобяные изделия'
    },
    {
        url: 'kraski',
        name: 'Краски'
    },
    {
        url: 'dekor',
        name: 'Декор'
    },
    {
        url: 'osveshchenie',
        name: 'Освещение'
    },
    {
        url: 'hranenie',
        name: 'Хранение'
    },
    {
        url: 'kuhni',
        name: 'Кухни'
    },
    {
        url: '',
        name: 'Все отделы'
    },
]